<template>
	<div class="app" :class="{ 'no-scroll': isShowRoomPictureOpen, 'is-inpwa': $isPwa() }">
		<AppHeader fixed :class="{ 'is-inpwa': $isPwa() }" :key="`${keyVersion}1`">
			<error-empty-token v-model="isEmptyTokenData" @error-empty-token:closed="onErrorEmptyTokenClosed" />
			<b-row class="ml-0">
				<BackInHistoryBtn v-if="$isPwa()" :key="`${keyVersion}2`" class="mr-3" />
				<SidebarToggler ref="side-bar" class="d-lg-none" display="sm" mobile :key="`${keyVersion}3`" />
				<button
					v-if="$screen.width <= 567"
					type="button"
					class="btn mx-0 btn-outline-primary btn-sm"
					style="width: 32px; height: 26px; margin-top: 3px"
					@click="backToMyDashboard"
				>
					<home :size="16" />
				</button>
				<a class="navbar-brand" style="cursor: pointer">
					<img
						class="navbar-brand-full"
						src="img/brand/thegreenshot-brand.png"
						@onclick="document.location.href = `#/my-dashboard${version}`"
						width="100"
						height="30"
						alt="TheGreenShot"
					/>
					<img class="navbar-brand-minimized" src="img/brand/tgs-icon.svg" width="30" height="30" alt="TGS" />
				</a>
				<SidebarToggler ref="side-bar" class="d-md-down-none" display="sm" :key="`${keyVersion}4`" />
				<b-navbar-nav class="d-md-down-none">
					<HeaderProjectToggler :key="`${keyVersion}5`" />
					<button
						type="button"
						class="btn mx-0 btn-outline-primary btn-sm ml-2"
						style="display: flex; align-items: center; justify-content: center; width: 32px; height: 26px"
						@click="backToMyDashboard"
					>
						<home :size="16" />
					</button>
					<button
						v-if="!isFilmSingle && !isFilmSingleFree && statusNotifications && isProduction"
						v-b-tooltip.hover.bottom.html="`${FormMSG(301, 'Add new project')}`"
						type="button"
						class="btn mx-0 btn-outline-primary btn-sm ml-2"
						style="display: flex; align-items: center; justify-content: center; width: 32px; height: 26px"
						@click="handleActionModal"
					>
						<Plus :size="16" />
					</button>
					<div v-if="titleProjectForArtiste" class="px-3 text-primary fw-500">{{ titleProjectForArtiste }}</div>
				</b-navbar-nav>
			</b-row>
			<b-row class="mr-0">
				<b-navbar-nav class="">
					<HeaderLanguageToggler :style="`${$screen.width < 992 ? 'margin-right: 2px; ' : ''}`" :key="`${keyVersion}6`" class="mr-2" />
					<b-nav-item>
						<b-dropdown
							size="sm"
							id="dropdown-header-help"
							:text="menuLabel()"
							class="dropdown--large"
							v-if="$screen.width >= 992"
							variant="outline-primary"
							right
						>
							<b-dropdown-item @click="openDocumentation()">
								{{ FormMSG(19946, 'Online guide') }}
							</b-dropdown-item>
							<b-dropdown-item @click="downloadStartUpGuide()">
								{{ FormMSG(19947, 'Quick Startup PDF Guide') }}
							</b-dropdown-item>
							<b-dropdown-item v-if="isFilmSingle" @click="showWizard">
								{{ FormMSG(19948, 'View wizard') }}
							</b-dropdown-item>
						</b-dropdown>
						<b-dropdown
							size="sm"
							id="dropdown-header-help"
							variant="outline-primary"
							toggle-class="text-decoration-none"
							class="dropdown--large"
							style="width: 32px"
							no-caret
							v-else
						>
							<template #button-content>
								<help-circle :size="16" />
							</template>
							<b-dropdown-item @click="openDocumentation()">
								{{ FormMSG(19946, 'Online guide') }}
							</b-dropdown-item>
							<b-dropdown-item @click="downloadStartUpGuide()">
								{{ FormMSG(19947, 'Quick Startup PDF Guide') }}
							</b-dropdown-item>
							<b-dropdown-item v-if="isFilmSingle" @click="showWizard">
								{{ FormMSG(19948, 'View wizard') }}
							</b-dropdown-item>
						</b-dropdown>
					</b-nav-item>
					<div v-if="!statusNotifications">
						<HeaderNotifications :key="`${keyVersion}7`" />
					</div>
					<b-nav-item class="ml-2">
						<DefaultHeaderDropdownAccnt ref="dropdown-accnt" :key="`${keyVersion}8`" />
					</b-nav-item>
				</b-navbar-nav>
			</b-row>
		</AppHeader>
		<div
			class="app-body"
			id="app-body"
			:class="{
				'is-pwa': $isPwa(),
				'is-ios': $isIOSDevice(),
				'is-android': $isAndroidDevice()
			}"
		>
			<AppSidebar dropdown-mode="close" fixed :key="`${keyVersion}9`">
				<SidebarHeader :key="`${keyVersion}10`" />
				<SidebarForm :key="`${keyVersion}11`" />
				<SidebarNav :nav-items="getNavItems" class="bg-secondary" :key="`${keyVersion}12`" />
				<SidebarFooter :key="`${keyVersion}13`" />
				<SidebarMinimizer :key="`${keyVersion}14`" />
			</AppSidebar>
			<main class="main">
				<Breadcrumb v-if="$screen.width < 576" :list="list" />
				<div class="container-fluid pt-3" :key="`${keyVersion}18`">
					<router-view />
				</div>
			</main>
			<AppAside fixed :key="`${keyVersion}15`">
				<DefaultAside :key="`${keyVersion}16`" />
			</AppAside>
		</div>
		<TheFooter :key="`${keyVersion}17`">
			<div class="ml-auto">
				<span class="ml-1">&copy; {{ copyright }} </span>
				<a href="https://www.thegreenshot.green" target="_blank" rel="noopener noreferrer">TheGreenShot</a>
			</div>
		</TheFooter>
		<tip-modal-component :key="`${keyVersion}18`" />
		<help-modal-component :key="`${keyVersion}19`" />
		<PreviewShowRoomImage :key="`${keyVersion}20`" />
		<modal-wizard :key="`${keyVersion}21`" />
		<b-modal
			size="xxl"
			v-model="open"
			no-close-on-backdrop
			:title="`${FormMSG(301, 'Add new project')}`"
			dialog-class="dialog-custom font-weight-bold"
			modal-class="mui-animation"
			:fade="false"
		>
			<Fimalac />
			<template #modal-footer>
				<div class="d-flex flex-row justify-content-end w-100 gap-1 w-1">
					<div>
						<b-button variant="outline-primary" size="sm" class="border-1" @click="handleActionModal"> {{ FormMSG(302, 'Close') }} </b-button>
					</div>
				</div>
			</template>
		</b-modal>
	</div>
</template>

<script>
import nav from '@/_nav';
import {
	Header as AppHeader,
	SidebarToggler,
	Sidebar as AppSidebar,
	SidebarFooter,
	SidebarForm,
	SidebarHeader,
	SidebarMinimizer,
	Aside as AppAside,
	Footer as TheFooter,
	Breadcrumb
} from '@coreui/vue';
import SidebarNav from '@/components/Forks/SidebarNav';
import DefaultAside from './DefaultAside';
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt';
import HeaderProjectToggler from '../components/HeaderProjectToggler';
import HeaderLanguageToggler from '../components/HeaderLanguageToggler';
import HeaderNotifications from '../components/HeaderNotifications';
import TipModalComponent from '../components/Modals/TipModal';
import ModalWizard from '../components/Modals/ModalWizard';
import HelpModalComponent from '../components/Modals/HelpModal';
import BackInHistoryBtn from '@/components/BackInHistoryBtn';
import PreviewShowRoomImage from '@/components/Packages/FIlesPreviewer/components/MainModalContainer';
import languageMessages from '@/mixins/languageMessages';
import { getParamVersion } from '@/shared/version';
import moment from 'moment';
import { Wand, HelpCircle, Home, Plus } from 'lucide-vue';
import { store } from '@/store';
import isSingleProjectMixin from '@/mixins/isSingleProject.mixin';
import globalMixin from '@/mixins/global.mixin';
import _ from 'lodash';
import { GetPlanningValidation } from '@/cruds/users.crud';
import Fimalac from '@/views/projects/FimalacProject';
import { mapGetters, mapActions } from 'vuex';
import ErrorEmptyToken from '@/components/Modals/ErrorEmptyTokenModal';
import vuexStore from '@/store/store';
import { nextTick } from 'process';
import { isNil } from '@/shared/utils';

export default {
	name: 'DefaultContainer',
	components: {
		AppHeader,
		AppSidebar,
		AppAside,
		TheFooter,
		Breadcrumb,
		DefaultAside,
		DefaultHeaderDropdownAccnt,
		SidebarForm,
		BackInHistoryBtn,
		SidebarFooter,
		SidebarToggler,
		SidebarHeader,
		SidebarNav,
		SidebarMinimizer,
		HeaderProjectToggler,
		HeaderLanguageToggler,
		HeaderNotifications,
		TipModalComponent,
		HelpModalComponent,
		PreviewShowRoomImage,
		Wand,
		HelpCircle,
		Home,
		Plus,
		ModalWizard,
		Fimalac,
		ErrorEmptyToken
	},
	mixins: [languageMessages, isSingleProjectMixin, globalMixin],
	data: function () {
		return {
			// Initialize your apollo data
			shared: store.state,
			tipOfTheDay: {},
			version: getParamVersion(),
			project: null,
			screenWidth: window.innerWidth,
			// navItems: [],
			open: false,
			statusNotifications: false,
			validationPlanningType: false,
			isTokenChanged: false,
			isMobile: false
			// navItems: [],
		};
	},
	async created() {
		// moment.tz.setDefault('GMT');
		const response = await this.initialize();
		if (response) {
			window.addEventListener('resize', this.updateScreenWidth);
		}
	},
	beforeDestroy() {
		// Remove the event listener to prevent memory leaks
		window.removeEventListener('resize', this.updateScreenWidth);
	},
	watch: {
		isMobile: async function (newValue, oldValue) {
			// Perform action when 'screen-size' is like a mobilescreen
			this.isTokenChanged = true;
			// this.navItems = [];
			await this.generateNavigation();
		},
		isShowFimalacPlanning: {
			async handler(newVal) {
				this.isTokenChanged = true;
				await this.generateNavigation();
				return newVal;
			},
			immediate: true,
			deep: true
		},
		isProduction: {
			async handler(newVal) {
				this.isTokenChanged = true;
				await this.generateNavigation();
				return newVal;
			},
			immediate: true,
			deep: true
		},
		needWatchVuexStore: {
			async handler(newVal) {
				if (newVal) {
					nextTick(async () => {
						this.isTokenChanged = true;
						await this.generateNavigation();
					});
				}
				return newVal;
			},
			immediate: true,
			deep: true
		},
		'shared.myProject.id': async function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue) {
				this.isTokenChanged = true;
				await this.generateNavigation();
			}
		},
		'myProfile.upm': async function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue && !this.isTokenChanged) {
				this.isTokenChanged = true;
				await this.generateNavigation();
			}
		},
		'myProfile.gateKeeper': async function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue && !this.isTokenChanged) {
				this.isTokenChanged = true;
				await this.generateNavigation();
			}
		},
		'myProfile.productionAccountant': async function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue && !this.isTokenChanged) {
				this.isTokenChanged = true;
				await this.generateNavigation();
			}
		},
		'myProfile.lineProducer': async function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue && !this.isTokenChanged) {
				this.isTokenChanged = true;
				await this.generateNavigation();
			}
		},
		'myProfile.studio': function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue && !this.isTokenChanged) {
				this.isTokenChanged = true;
				this.generateNavigation();
			}
		},
		'myProfile.canValidateI9': async function (newValue, oldValue) {
			if (!isNil(newValue) && newValue !== oldValue && !this.isTokenChanged) {
				this.isTokenChanged = true;
				await this.generateNavigation();
			}
		},
		tipOfTheDay: {
			handler(newVal) {
				return newVal;
			},
			immediate: true,
			deep: true
		},
		$route: {
			handler(to, from) {},
			immediate: true
		},
		screenWidth: {
			async handler(newVal) {
				return newVal;
			},
			immediate: true,
			deep: true
		}
	},
	computed: {
		...mapGetters({
			getNavItems: 'nav-items/getNavItems',
			isEmptyTokenData: 'header/getEmptyTokenData',
			getCurrentProjectConfig: 'config/getCurrentProjectConfig',
			getSavedNoTranslationMenus: 'config/getSavedNoTranslationMenus',
			isLoaded: 'config/isLoaded',
			myProject: 'config/myProject',
			getToken: 'config/getToken',
			isShowFimalacPlanning: 'config/isShowFimalacPlanning',
			userID: 'config/userID',
			isPme: 'config/isPme',
			isFilm: 'config/isFilm',
			appLanguage: 'config/appLanguage',
			isProd: 'config/isProd',
			isAdmin: 'config/isAdmin',
			isFilmSingleUserFree: 'config/isFilmSingleUserFree',
			isFilmSingleUser: 'config/isFilmSingleUser',
			isDev: 'config/isDev',
			canManageCrewList: 'config/canManageCrewList',
			canManageDocumentPackage: 'config/canManageDocumentPackage',
			tokenObject: 'config/tokenObject',
			canManageLocations: 'config/canManageLocations',
			canAccessConfig: 'config/canAccessConfig',
			// isTranslator: 'config/isTranslator',
			myProfile: 'config/myProfile',
			// canExportImport: 'config/canExportImport',
			isGestionnaryOfPaie: 'config/isGestionnaryOfPaie',
			isProduction: 'config/isProduction'
		}),
		needWatchVuexStore() {
			return this.getToken;
		},
		titleProjectForArtiste() {
			const project = this.myProject;
			if (project) {
				const { projectArtiste } = project;
				return projectArtiste;
			}
			return null;
		},
		name() {
			return this.$route.name;
		},
		list() {
			return this.$route.matched.filter((route) => route.name || route.meta.label);
		},

		/**
		 * @return {Boolean}
		 */
		isShowRoomPictureOpen() {
			return this.$store.getters['app/isShowRoomPictureOpen'];
		},
		copyright() {
			return moment().format('YYYY');
		},
		keyVersion() {
			const version = getParamVersion();

			return version.replace('?v=', '');
		}
	},
	methods: {
		...mapActions({
			mutateNavItems: 'nav-items/mutateNavItems'
		}),
		isFeatureAllowed(feature) {
			// const isFeatureRestricted =
			// 	(feature.name === 'Timesheets planning' && !this.isShowFimalacPlanning) ||
			// 	(feature.name === 'Crew Setup' &&
			// 		((!this.canManageCrewList &&
			// 			!this.canManageDocumentPackage &&
			// 			!(
			// 				this.myProfile.upm ||
			// 				this.myProfile.gateKeeper ||
			// 				this.myProfile.productionAccountant ||
			// 				this.myProfile.lineProducer ||
			// 				this.myProfile.studio ||
			// 				this.myProfile.canValidateI9
			// 			)) ||
			// 			!this.myProject.useCrewSetup)) ||
			// 	(feature.name === 'Locations' && (!this.canManageLocations || !this.myProject.useLocations)) ||
			// 	(feature.name === 'Imports' && (!this.canExportImport || !this.myProject.useImport)) ||
			// 	(feature.name === 'Configuration' && !this.canAccessConfig) ||
			// 	(feature.name === 'Finance' && !this.isShowFimalacPlanning) ||
			// 	(feature.hasOwnProperty('notForFilm') && this.isFilm) ||
			// 	(feature.hasOwnProperty('notForMobile') && window.innerWidth <= 576) ||
			// 	(feature.hasOwnProperty('filmOnly') && !this.isFilm && !this.isFilmSingleUser && !this.isFilmSingleUserFree) ||
			// 	(feature.hasOwnProperty('pmeOnly') && !this.isPme) ||
			// 	(feature.hasOwnProperty('prodOnly') && !this.myProject.useProduction) ||
			// 	(feature.hasOwnProperty('useFinance') && !this.myProject.useFinance) ||
			// 	(feature.hasOwnProperty('translatorOnly') && !this.isTranslator) ||
			// 	(feature.hasOwnProperty('notForSingleUser') && (this.isFilmSingleUserFree || this.isFilmSingleUser)) ||
			// 	(feature.hasOwnProperty('devOnly') && !this.isDev) ||
			// 	(feature.hasOwnProperty('notForSingleProject') && (this.isFilmSingleUserFree || this.isFilmSingleUser));
			// return !isFeatureRestricted;
			const { useCrewSetup, useLocations } = this.myProject;
			const isDev = this.isDev;
			const accessLocation = [this.canManageLocations, useLocations].some((l) => l);
			const accessCrewSetup = this.isProduction ? [useCrewSetup, this.canManageCrewList].some((c) => c) : false;
			const theGreenShot = ['Translations', 'All users', 'Projects', 'Licenses', 'Scripts', 'Maintenance'];
			const production = ['Crew Setup'];
			const configuration = ['Project'];
			const finance = ['Timesheets planning'];
			const memberOfTeam = ['My Profile', 'My Project'];
			const isLevelUp = [this.isProduction, this.isGestionnaryOfPaie].some((s) => s);
			const isAuthorizeMenuFimalac = this.isShowFimalacPlanning;
			let navApps = [...memberOfTeam];
			if (isDev) {
				const arr = [...theGreenShot, 'Imports'];
				navApps.push(...arr);
			}
			if (isLevelUp) {
				navApps.push(...configuration);
			}
			if (accessCrewSetup) {
				navApps.push(...production);
			}
			if (isAuthorizeMenuFimalac) {
				navApps.push(...finance);
			}
			if (accessLocation) {
				const arr = ['Locations'];
				navApps.push(...arr);
			}
			const isAllowed = navApps.includes(feature.name);
			const isFeatureRestricted = isAllowed;
			return isFeatureRestricted;
		},
		removeNotAllowedChildren(menu, myProfile, projectConfig = {}) {
			if (menu.savedChildren.length === 0) {
				for (let i = 0; i < menu.children.length; i++) {
					menu.savedChildren.push(menu.children[i]);
				}
			}
			menu.children = [];

			for (let i = 0; i < menu.savedChildren.length; i++) {
				const saved = menu.savedChildren[i];
				const _isFeatureAllowed = this.isFeatureAllowed(saved, myProfile, projectConfig);
				if (_isFeatureAllowed) {
					menu.children.push(saved);
				}
			}

			return menu;
		},
		removeItemsWithNoChildren(arr) {
			const filteredArray = arr.filter((item) => item.children.length > 0);
			return filteredArray;
		},

		async generateNavigation() {
			//get current my project
			await this.getValidationPlanning();
			await this.useFimalac();
			const currentProjectConfig = this.getCurrentProjectConfig || {};
			if (!this.getNavItems[0] || this.isTokenChanged) {
				let newNavs = [];
				let i = 0;
				for (const elem of nav) {
					const result = this.removeNotAllowedChildren(elem, this.myProfile, currentProjectConfig);
					newNavs.push(result);
					i++;
				}
				const selectedFilterMenus = newNavs.filter(async (item) => this.isFeatureAllowed(item, this.myProfile, currentProjectConfig));
				const selectedMenuOptions = this.removeItemsWithNoChildren(selectedFilterMenus);
				const selectedMenuOptionsTranslated = this.translateMenuName(selectedMenuOptions, this.getSavedNoTranslationMenus);
				const mergedMenus = this.mergeArrays(this.getNavItems, selectedMenuOptionsTranslated, 'msgId');
				await this.mutateNavItems({ isUpdate: false, navs: mergedMenus });
				this.isTokenChanged = false;
				return true;
			}
			return false;
		},
		async initialize() {
			nextTick(async () => {
				const loaded = this.isLoaded;
				if (loaded) {
					const generate = await this.generateNavigation();
					if (generate) {
						return true;
					}

					return false;
				}
				return false;
			});
		},
		async getValidationPlanning() {
			if (this.userID) {
				const result = await GetPlanningValidation(this.userID);
				if (result) {
					let type_status = result.validationLevelTs;
					this.validationPlanningType = !!type_status;
					return this.validationPlanningType;
				}
				return this.validationPlanningType;
			}
			return false;
		},
		async useFimalac() {
			const project = this.myProject;
			const license = !isNil(project.license) ? project.license.license : '';
			const isFimalacLicense = /fimalac/gi.test(license);
			const status = this.isShowFimalacPlanning && isFimalacLicense;
			this.statusNotifications = status;
		},
		handleActionModal() {
			this.open = !this.open;
		},
		translateMenuName(items, noTranslationMenus) {
			return items.map((item) => {
				const id = this.getMsgIdForProjectType(item);
				let message = '';
				if (item.hasOwnProperty('titleUpdatable') && item.titleUpdatable === true) {
					message = this.getCostumTitle(id, {
						userName: noTranslationMenus.userName,
						hodName: noTranslationMenus.hodName,
						managerName: noTranslationMenus.managerName
					});

					if (message === null) {
						message = this.FormMSG(id, this.getMsgNameForProjectType(item));
					}
				} else {
					message = this.FormMSG(id, this.getMsgNameForProjectType(item));
				}

				// format the final menu
				let menu = {
					...item,
					name: message
				};

				if (item.hasOwnProperty('children') && item.children.length > 0) {
					menu.children = this.translateMenuName(menu.children, noTranslationMenus);
				}

				return menu;
			});
		},
		mergeArrays(oldArray, newArray, uniqueIdentifier) {
			if (!oldArray.length) {
				return newArray;
			} else {
				const mergedArray = newArray.map((item1) => {
					const matchingItem = oldArray.find((item2, index) => {
						const isFind = item2[uniqueIdentifier] === item1[uniqueIdentifier] && item2['name'] && !item2['name'].toString().includes('_');
						return isFind;
					});

					if (matchingItem) {
						return { ...item1, open: matchingItem.open };
					}
					return item1;
				});

				return mergedArray;
			}
		},
		updateScreenWidth() {
			this.screenWidth = window.innerWidth; // Update screen width when called
		},
		showWizard() {
			this.$bvModal.show('wizard-modal');
		},
		backToMyDashboard() {
			return this.$router.push({ name: 'My Dashboard' });
		},
		menuLabel() {
			return this.FormMSG(19998, 'Help');
		},
		getMsgIdForProjectType(feature) {
			//  console.log("in getMsgIdForProjectType feature:",feature);
			if (this.isPme) {
				if (feature.hasOwnProperty('msgIdPme')) {
					//console.log("in getMsgIdForProjectType FOUND msgIdPme:",feature);
					return feature.msgIdPme;
				}
			}
			return feature.msgId;
		},
		getMsgNameForProjectType(feature) {
			if (this.isPme) {
				if (feature.hasOwnProperty('namePme')) {
					//console.log("in getMsgIdForProjectType FOUND namePME:",feature);
					return feature.namePme;
				}
			}
			return feature.name;
		},
		getCostumTitle(id, { userName, hodName, managerName }) {
			let title = null;
			if ((id === 71 || id === 171) && userName !== '') {
				title = userName;
			}

			if ((id === 11 || id === 111) && hodName !== '') {
				title = hodName;
			}

			if ((id === 18 || id === 118) && managerName !== '') {
				title = managerName;
			}

			return title;
		},
		downloadStartUpGuide() {
			let currLang = 0;
			if (this.appLanguage) {
				currLang = this.appLanguage;
			}
			let userLevel = this.isProd ? 2 : this.isAdmin ? 1 : 0;
			let projectType = this.myProject.projectType;
			var urlStr = process.env.VUE_APP_GQL + '/getQuickStartUpGuide/' + currLang + '/' + projectType + '/' + userLevel;

			if ((this.isFilmSingleUserFree || this.isFilmSingleUser) && currLang === 1) {
				urlStr = 'https://docs.thegreenshot.green/fr-quick-solo-film/';
			} else if ((this.isFilmSingleUserFree || this.isFilmSingleUser) && currLang !== 1) {
				urlStr = 'https://docs.thegreenshot.green/en-quick-start-solo-film/';
			}
			window.open(urlStr); // in a new window
		},
		openDocumentation() {
			this.$bvModal.show('help-documentation-modal');
		},
		onErrorEmptyTokenClosed() {
			store.onLogout();
		}
	}
};
</script>

<style>
#dropdown-header-help .dropdown-menu.dropdown-menu-right.show {
	min-width: 240px;
}
.app.no-scroll {
	overflow: hidden !important;
	height: 100vh !important;
}
.dialog-custom {
	max-width: 90% !important;
}
</style>
